<template lang="pug">
.basic-filters
  label Members
  AppSelect(
    v-model="selected"
    :options="options"
    :select2-options="select2Options"
  )
</template>

<script>
export default {
  name: 'JobSitesMemberFilter',
  props: {
    options: {
      type: Array,
      required: true,
    },
    selectedMemberIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['input'],
  data() {
    const select2Options = {
      allowClear: true,
      multiple: true,
      placeholder: 'All members',
      width: '100%',
    };

    return {
      select2Options,
    };
  },
  computed: {
    selected: {
      get() {
        return this.selectedMemberIds;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
